module.exports = __webpack_public_path__ + "static/media/payment-promise-calendar.c52e377c.svg";